import React from "react";

type Props = {
  requiredRole: string;
  children: any; //React.ReactNode
};

export default function CanAccess({ requiredRole, children }: Props) {
  const hasPermission = requiredRole === localStorage.getItem("role")


  return <>{ hasPermission &&  children}</>;
}
